export default __webpack_public_path__ + "img/bg-mobile-illustration-light.svg";